export class ExpiredParentWindowSession extends Error {}
export class UnknownFailure extends Error {}
